<template>
  <div class="tab-content">
    <!--Seccion K -->
    <CustomInnerPageMessage v-if="isShowMessage" />
    <SectionTitle
      icon="fas fa-address-card"
      content="VI. Otras Consideraciones y Servicios"
      container-class="tag-badge-main-info mt-5 mb-3"
    />
    <SectionTitle
      :has-line="true"
      content="K. Servicios y equipos de asistencia tecnológica (AT)"
      container-class="mt-2 mb-4"
    />
    <div
      v-if="
        validationTriggered.validation &&
          validationTriggered.hasErrors('Tab7', 'AT-Alt-ubi-error')
      "
      class="ml-3 mb-3"
    >
      <Error
        :message="validationTriggered.errors('Tab7', 'AT-Alt-ubi-error')"
        variant="withoutspacing no-border"
      />
    </div>
    <div>
      <div>
        <div class="eq-ask row">
          <strong class="col-12 mb-2 ml-3">
            Información de Guía de Referido de AT en MIPE
          </strong>
        </div>
        <div class="panel-simple">
          <div class="header">
            <div class="col-md-6">
              <span>Evaluación y/o servicios de AT dirigidos a</span>
            </div>
            <div class="col-md-6">
              <PreEvaluationAnswer
                v-if="
                  preEvaluationAnswerVisible &&
                    otherServTechAssistEquipFlag == '1'
                "
                :is-new="true"
                :call-back="callChild"
                @showMessage="showMessage"
              />
            </div>
          </div>
          <div v-if="Referals.length == 0" class="text-center">
            <p class="mt-4" style="color: #d0d0d0; font-weight: normal">
              No hay Guía de Referido existente
            </p>
          </div>

          <!--Seccion K1-->
          <!--JOSE GONZALEZ SANTIAGO-->
          <div
            v-for="(item, i) in Referals"
            :key="i"
            class="row align-items-center justify-content-between right-separator w-100"
          >
            <div class="panel-row col-12 py-3">
              <div class="info col-2">
                <span>
                  <strong>
                    Número de Referido:
                    <br />
                  </strong>
                </span>
                <span>{{ item.referalNo }}</span>
              </div>
              <div class="status col-2">
                <span>
                  <b>
                    Estatus de la Guía:
                    <br />
                  </b>
                </span>
                <span>
                  {{ item.completeFlag ? 'Completado' : 'No Completado' }}
                </span>
              </div>
              <div class="status col-2">
                <span>
                  <b>
                    Estatus Referido:
                    <br />
                  </b>
                </span>
                <span>
                  {{ item.serviceStatusName }}
                </span>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-10 d-flex flex-row flex-wrap mt-3 mb-3">
                    <div class="tag type1 necessity mr-2">
                      <span>Necesidades</span>
                    </div>
                    <div
                      v-for="(N, id) in item.peiAtServiceNecessityDTO"
                      :key="id"
                      class="tag necessity"
                    >
                      <span>
                        {{
                          N.otherName != ''
                            ? 'Otros - ' + N.otherName
                            : N.nameToShow
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="col-2">
                    <span>
                      <div class="dropdown">
                        <button
                          v-if="
                            canEditTab7 &&
                              (admendmentIsEmpty ||
                                !canUseTabEditRestriction ||
                                hasSubSectionKinAmendant)
                          "
                          id="dropdownMenuButton"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Acciones
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <div class="dropdown-item" @click="goToAT(item)">
                            <em
                              :class="
                                item.completeFlag
                                  ? 'fa fa-eye text-green pr-1'
                                  : 'fa fa-edit text-green pr-1'
                              "
                            />
                            <span>
                              {{
                                item.completeFlag || !IsDraft
                                  ? 'Leer'
                                  : 'Editar'
                              }}
                            </span>
                          </div>
                          <div
                            v-if="
                              IsDraft &&
                                !item.completeFlag &&
                                (admendmentIsEmpty ||
                                  !canUseTabEditRestriction ||
                                  hasSubSectionKinAmendant)
                            "
                            class="dropdown-item"
                            @click="DropATGuide(item)"
                          >
                            <em class="fas fa-times-circle text-red pr-1" />
                            <span>Eliminar</span>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              preEvaluationAnswerVisible &&
                otherServTechAssistEquipFlag == '1' &&
                IsDraft &&
                canEditTab7 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionKinAmendant)
            "
            class="text-center"
          >
            <button
              class="btn bg-light-white w-50 pt-1 mt-3"
              @click="preEvalClick()"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aquí para crear Guía de Referido para evaluación de AT
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <div class="eq-ask row">
          <strong class="col-12 mb-2 ml-3">
            Información de área en PEI previo a Guía de Referido
          </strong>
        </div>
        <div class="panel-simple">
          <div class="header">
            <div class="col-md-6">
              <span>Evaluación y/o servicios de AT dirigidos a</span>
            </div>
          </div>
          <div
            v-if="
              !preReferalsClicked &&
                preReferals.length == 0 &&
                otherServTechAssistEquipFlag == '1' &&
                IsDraft &&
                isAtConverted &&
                canEditTab7 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionKinAmendant)
            "
            class="text-center"
          >
            <button
              class="btn bg-light-white w-50 pt-1 mt-3"
              @click="preReferalClick()"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aquí para crear área en PEI previo a Guía de Referido
              </span>
            </button>
          </div>
          <div
            v-if="preReferals.length == 0 && (!IsDraft || canEditTab7)"
            class="text-center"
          >
            <p class="mt-4" style="color: #d0d0d0; font-weight: normal">
              No hay área en PEI previo a Guía de Referido existente
            </p>
          </div>
          <div v-if="preReferalsClicked && otherServTechAssistEquipFlag == '1'">
            <div>
              <div class="container-fluid my-2">
                <div class="card-body">
                  <div class="panel-body">
                    <MultiSelectionPicker
                      maxlength="1500"
                      :all-items="preReferalsAvailable"
                      :selected-items="preReferals"
                      item-type-name="Equipo"
                      :column-count="1"
                    />
                    <CustomChipsGroup
                      title="Equipos Seleccionados"
                      :selected-items="preReferals"
                      :no-wrap="true"
                      object-text="name"
                      @itemMarkedForDeletion="removeSelectionReferal"
                    />
                  </div>
                </div>
              </div>
              <div class="actions" style="float: right">
                <ActionButton
                  i="fas fa-times-circle"
                  variant="danger m-2"
                  @click="cancelPreReferal"
                >
                  Cancelar
                </ActionButton>
                <ActionButton
                  i="fas fa-save"
                  variant="success m-2"
                  @click="savePreReferal"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
          <div
            v-if="
              !preReferalsClicked &&
                preReferals.length > 0 &&
                otherServTechAssistEquipFlag == '1'
            "
          >
            <div
              class="row align-items-center justify-content-between right-separator w-100"
            >
              <div class="panel-row col-12 py-3">
                <div class="info col-2">
                  <div class="tag type1">
                    <b>Necesidades</b>
                  </div>
                </div>
                <div class="col-8">
                  <div class="row">
                    <div
                      v-for="(item, i) in preReferals"
                      :key="i"
                      class="tag type2 necessity"
                    >
                      <span>{{ item.name }}</span>
                      <span style="color: red">
                        <i
                          v-if="IsDraft && isAtConverted && canEditTab7"
                          class="mt-1 ml-2 far fa-times-circle pointer red"
                          @click.prevent.stop="onReferalDeleted(item.id)"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="IsDraft && isAtConverted && canEditTab7"
              style="float: right"
            >
              <ActionButton
                v-if="IsDraft && isAtConverted && canEditTab7"
                i="fas fa-file-plus"
                variant="success m-2"
                @click="preReferalClick"
              >
                Añadir
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
      <Error
        v-if="validateGuideATNoComplete()"
        variant="no-border pt-5"
        :message="resources['6018']"
      />

      <Error
        v-if="validateProcessesContainInformation()"
        variant="no-border pt-5"
        :message="resources['R100561']"
      />

      <SectionTitle
        :has-line="true"
        content="Equipo asistivo recomendado por el Comité Asesor de Asistencia Tecnológica"
        container-class="mt-5 mb-4"
      />

      <!--Tabla k1 con div-->
      <div class="eq-ask row">
        <strong class="col-12 mb-2 ml-3">
          Información de Guía de Referido de AT en MIPE
        </strong>
      </div>
      <div class="container-table-striped w-100">
        <div class="table-hover">
          <table class="table content-table-striped table-h">
            <thead>
              <tr class="row global-thead-dark thead-property">
                <th class="col-5">
                  <b>Necesidad</b>
                </th>
                <th class="col-7 py-3">
                  <b>Equipo</b>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, i) in serviceAssistTechEquipCommittee"
                :key="i"
                class="row"
              >
                <td class="col-md-5 left-padding vertical-align-center">
                  <div class="tag type1">
                    <b>{{ item.name }}</b>
                  </div>
                </td>
                <td class="col-md-7 left-padding vertical-align-center">
                  <div class="row">
                    <div
                      v-for="(equipm, index) in item.equipments"
                      :key="index"
                      class="tag"
                    >
                      <b>{{ equipm.name }}</b>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="serviceAssistTechEquipCommittee.length == 0">
                <td colspan="2">
                  <div class="text-center">
                    <p class="mt-4" style="color: #d0d0d0">
                      No hay Guía de Referido existente
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mt-4">
        <div class="eq-ask row">
          <strong class="col-12 mb-2 ml-3">
            Información de área en PEI previo a Guía de Referido
          </strong>
        </div>
        <div class="container-table-striped w-100">
          <div class="table-hover">
            <table class="table content-table-striped table-h">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-5">
                    <b>Necesidad</b>
                  </th>
                  <th class="col-7 py-3">
                    <b>Equipo</b>
                  </th>
                </tr>
              </thead>
              <tbody
                v-if="
                  !preServiceAssistTechEquipCommitteeClicked &&
                    preServiceAssistTechEquipCommittee.length > 0 &&
                    otherServTechAssistEquipFlag == '1'
                "
              >
                <tr
                  v-for="(item,
                  i) in preServiceAssistTechEquipCommitteeFormatted"
                  :key="i"
                  class="row"
                >
                  <td class="col-md-5 left-padding vertical-align-center">
                    <div class="tag type1">
                      <b>{{ item.name }}</b>
                    </div>
                  </td>
                  <td class="col-md-7 left-padding vertical-align-center">
                    <div class="row">
                      <div
                        v-for="(equipm, index) in item.equipments"
                        :key="index"
                        class="tag"
                      >
                        <b>{{ equipm.name }}</b>
                        <span style="color: red">
                          <i
                            v-if="IsDraft && isAtConverted && canEditTab7"
                            class="mt-1 ml-2 far fa-times-circle pointer red"
                            @click.prevent.stop="
                              onCommitteeEquipmentDeleted(equipm.id)
                            "
                          />
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-if="!IsDraft || !isAtConverted || !canEditTab7">
                  <td colspan="2">
                    <div class="text-center">
                      <p class="mt-4" style="color: #d0d0d0">
                        No hay área en PEI previo a Guía de Referido existente
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="panel-simple">
          <div
            v-if="
              !preServiceAssistTechEquipCommitteeClicked &&
                preServiceAssistTechEquipCommittee.length == 0 &&
                otherServTechAssistEquipFlag == '1' &&
                IsDraft &&
                isAtConverted &&
                canEditTab7 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionKinAmendant)
            "
            class="text-center"
          >
            <button
              class="btn bg-light-white w-50 pt-1 mt-3"
              @click="preServiceAssistTechEquipCommitteeClick()"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aquí para crear área en PEI previo a Guía de Referido
              </span>
            </button>
          </div>
          <div
            v-if="
              preServiceAssistTechEquipCommitteeClicked &&
                otherServTechAssistEquipFlag == '1'
            "
          >
            <div>
              <div class="container-fluid my-2">
                <div class="card-body">
                  <div class="panel-body">
                    <div class="col-12">
                      <CustomDropDown
                        v-model="selectedFilterCommite"
                        placeholder="Seleccione área"
                        label="Áreas:"
                        fieldkey="id"
                        fieldname="name"
                        :options="equipmentFilter"
                        class="w-50 mb-3"
                      />
                    </div>

                    <MultiSelectionPicker
                      maxlength="1500"
                      :all-items="preTechCommitteeFiltered"
                      :selected-items="preServiceAssistTechEquipCommittee"
                      item-type-name="Equipo"
                      :column-count="1"
                    />
                    <CustomChipsGroup
                      title="Equipos Seleccionados"
                      :selected-items="preServiceAssistTechEquipCommittee"
                      :no-wrap="true"
                      object-text="name"
                      @itemMarkedForDeletion="removeSelectionCommiteEquipment"
                    />
                  </div>
                </div>
              </div>
              <div class="actions" style="float: right">
                <ActionButton
                  i="fas fa-times-circle"
                  variant="danger m-2"
                  @click="cancelPreServiceAssistTechEquipCommittee"
                >
                  Cancelar
                </ActionButton>
                <ActionButton
                  i="fas fa-save"
                  variant="success m-2"
                  @click="savePreServiceAssistTechEquipCommittee"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
          <div
            v-if="
              !preServiceAssistTechEquipCommitteeClicked &&
                preServiceAssistTechEquipCommittee.length > 0 &&
                otherServTechAssistEquipFlag == '1'
            "
            style="float: right"
          >
            <ActionButton
              v-if="IsDraft && isAtConverted && canEditTab7"
              i="fas fa-file-plus"
              variant="success m-2"
              @click="preServiceAssistTechEquipCommitteeClick"
            >
              Añadir
            </ActionButton>
          </div>
        </div>
      </div>

      <Error
        v-if="validateProcessesContainInformation()"
        variant="no-border pt-5"
        :message="resources['R100561']"
      />

      <!--Seccion K2-->
      <SectionTitle
        :has-line="true"
        content="Equipo asistivo disponible en la escuela"
        container-class="mt-5 mb-4"
      />

      <!--Tabla 2 con div-->
      <div class="eq-ask d-flex justify-content-between align-items-center">
        <strong class="mb-2 ml-3">
          Información de Guía de Referido de AT en MIPE
        </strong>
        <ActionButton
          v-if="canShowGuarantaeeUsageAction"
          i="fas fa-file-edit"
          variant="success m-2"
          @click="guarantaeeUsageHandler"
        >
          {{
            IsDraft &&
            (admendmentIsEmpty ||
              !canUseTabEditRestriction ||
              hasSubSectionKinAmendant)
              ? 'Modificar'
              : 'Ver'
          }}
        </ActionButton>
      </div>
      <div class="ml-3">
        <Error
          v-if="
            validationTriggered.validation &&
              validationTriggered.hasErrors('Tab7', 'AT-Guarantee')
          "
          :message="validationTriggered.errors('Tab7', 'AT-Guarantee')"
          variant="withoutspacing no-border"
        />
      </div>
      <div class="container-table-striped w-100">
        <div class="table-hover">
          <table class="table content-table-striped table-h">
            <thead>
              <tr class="row global-thead-dark thead-property">
                <th class="col-5">
                  <b>Necesidad</b>
                </th>
                <th class="col-7 py-3">
                  <b>Equipo</b>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in TechEquipInSchool" :key="i" class="row">
                <td class="col-md-5 left-padding vertical-align-center">
                  <div class="tag type1">
                    <b>{{ item.name }}</b>
                  </div>
                </td>
                <td class="col-md-7 left-padding vertical-align-center">
                  <div class="row">
                    <div
                      v-for="(equipm, index) in item.equipments"
                      :key="index"
                      class="tag"
                    >
                      <b>{{ equipm.name }}</b>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                v-if="
                  TechEquipInSchool != null && TechEquipInSchool.length == 0
                "
              >
                <td colspan="2">
                  <div class="text-center">
                    <p class="mt-4" style="color: #d0d0d0">
                      No hay Guía de Referido existente
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <Error
            v-if="
              removedEquipments.length > 0 &&
                (this.selectedPeiStatus === parseInt(peiStatus.Borrador) ||
                  this.selectedPeiStatus === parseInt(peiStatus.Completado))
            "
            is-alert-mode
            :message="
              `El o los equipo(s) [${removedEquipments.join(
                ', '
              )}] ha sido marcado que no requiere continuar con el uso del mismo. Al momento de Firmar el PEI el mismo será removido.`
            "
          />
        </div>
      </div>
      <div class="mt-4">
        <div class="eq-ask row">
          <strong class="col-12 mb-2 ml-3">
            Información de área en PEI previo a Guía de Referido
          </strong>
        </div>

        <div class="container-table-striped w-100">
          <div class="table-hover">
            <table class="table content-table-striped table-h">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-5">
                    <b>Necesidad</b>
                  </th>
                  <th class="col-7 py-3">
                    <b>Equipo</b>
                  </th>
                </tr>
              </thead>
              <tbody
                v-if="
                  !preTechEquipInSchoolClicked &&
                    preTechEquipInSchool.length > 0 &&
                    otherServTechAssistEquipFlag == '1'
                "
              >
                <tr
                  v-for="(item, i) in preTechEquipInSchoolFormatted"
                  :key="i"
                  class="row"
                >
                  <td class="col-md-5 left-padding vertical-align-center">
                    <div class="tag type1">
                      <b>{{ item.name }}</b>
                    </div>
                  </td>
                  <td class="col-md-7 left-padding vertical-align-center">
                    <div class="row">
                      <div
                        v-for="(equipm, index) in item.equipments"
                        :key="index"
                        class="tag"
                      >
                        <b>{{ equipm.name }}</b>
                        <span style="color: red">
                          <i
                            v-if="IsDraft && isAtConverted && canEditTab7"
                            class="mt-1 ml-2 far fa-times-circle pointer red"
                            @click.prevent.stop="
                              onSchoolEquipmentDeleted(equipm.id)
                            "
                          />
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-if="!IsDraft || !isAtConverted || canEditTab7">
                  <td colspan="2">
                    <div class="text-center">
                      <p class="mt-4" style="color: #d0d0d0">
                        No hay área en PEI previo a Guía de Referido existente
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="panel-simple">
          <div
            v-if="
              !preTechEquipInSchoolClicked &&
                preTechEquipInSchool.length == 0 &&
                otherServTechAssistEquipFlag == '1' &&
                IsDraft &&
                isAtConverted &&
                canEditTab7 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSubSectionKinAmendant)
            "
            class="text-center"
          >
            <button
              class="btn bg-light-white w-50 pt-1 mt-3"
              @click="preTechEquipInSchoolClick()"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aquí para crear área en PEI previo a Guía de Referido
              </span>
            </button>
          </div>
          <div
            v-if="
              preTechEquipInSchoolClicked && otherServTechAssistEquipFlag == '1'
            "
          >
            <div>
              <div class="container-fluid my-2">
                <div class="card-body">
                  <div class="panel-body">
                    <div class="col-12">
                      <CustomDropDown
                        v-model="selectedFilterSchool"
                        placeholder="Seleccione área"
                        label="Áreas:"
                        fieldkey="id"
                        fieldname="name"
                        :options="equipmentFilter"
                        class="w-50 mb-3"
                      />
                    </div>
                    <MultiSelectionPicker
                      maxlength="1500"
                      :all-items="preTechSchoolFiltered"
                      :selected-items="preTechEquipInSchool"
                      item-type-name="Equipo"
                      :column-count="1"
                    />
                    <CustomChipsGroup
                      title="Equipos Seleccionados"
                      :selected-items="preTechEquipInSchool"
                      :no-wrap="true"
                      object-text="name"
                      @itemMarkedForDeletion="removeSelectionSchool"
                    />
                  </div>
                </div>
              </div>
              <div class="actions" style="float: right">
                <ActionButton
                  i="fas fa-times-circle"
                  variant="danger m-2"
                  @click="cancelPreTechEquipInSchool"
                >
                  Cancelar
                </ActionButton>
                <ActionButton
                  i="fas fa-save"
                  variant="success m-2"
                  @click="savePreTechEquipInSchool"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
          <div
            v-if="
              !preTechEquipInSchoolClicked &&
                preTechEquipInSchool.length > 0 &&
                otherServTechAssistEquipFlag == '1'
            "
            style="float: right"
          >
            <ActionButton
              v-if="IsDraft && isAtConverted && canEditTab7"
              i="fas fa-file-plus"
              variant="success m-2"
              @click="preTechEquipInSchoolClick"
            >
              Añadir
            </ActionButton>
          </div>
        </div>
      </div>
      <Error
        v-if="validateProcessesContainInformation()"
        variant="no-border pt-5"
        :message="resources['R100561']"
      />

      <!--Seccion VII-->
      <div v-if="!isPs">
        <SectionTitle
          icon="fas fa-calendar-alt"
          content="VII. Año Escolar Extendido"
          container-class="tag-badge-main-info mt-5 mb-4"
        />
        <Error
          v-if="pei.extendedSchoolYearFlag != 1"
          is-alert-mode
          :message="resources['R03200137']"
        />
      </div>

      <div v-if="pei.extendedSchoolYearFlag == 1">
        <Error
          v-if="controversyVII && controversyVII.existControversy"
          is-alert-mode
          :message="
            '<b>Parte en Controversia: </b>' + controversyVII.informationMessage
          "
        />

        <div
          v-if="ListServiceAreaExtendedSchoolYear.length == 0"
          class="p-custom mb-5"
        >
          Indique los servicios educativos y relacionados o áreas del PEI que
          requieren ser implementadas durante el año escolar extendido, así como
          la frecuencia de los mismos.
        </div>
        <div
          v-if="ListServiceAreaExtendedSchoolYear.length > 0"
          class="p-custom mb-5"
        >
          Servicios educativos y relacionados o áreas del PEI que requieren ser
          implementadas durante el año escolar extendido
        </div>
      </div>
    </div>

    <ValidationObserver ref="formPeiTab7" v-slot="{ dirty }">
      <SaveObserver name="saveObserverPeiTab7" :dirty="dirty">
        <div v-if="extendedSchoolYearFlag == 1" class="panel-simple">
          <div class="header global-thead-dark">
            <div class="col-md-12 text-center">
              <span>Año Escolar Extendido {{ AcademicYearDescription }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <Accordion id="peiTab7">
                <AccordionItem
                  v-for="(item, index) in ListServiceAreaExtendedSchoolYear"
                  :id="`psa-${item.areaId + '_' + index}`"
                  :key="item.areaId + '_' + index"
                  :ref="`psa-${item.areaId + '_' + index}`"
                  :title="serviceName(item)"
                  title-style="col-md-3 text-left"
                  content-style="col-md-7 text-left"
                  action-style="col-md-2 text-right"
                >
                  <div slot="content" class="card-body">
                    <div
                      v-if="isEducativo(item)"
                      class="row border-bottom pb-4 ml-3"
                    >
                      <div class="info col-6 pt-0">
                        <span>
                          <b class="b-text">Frecuencia:</b>
                          <br />
                        </span>
                        <span class="normal-text-no-margin">
                          {{ item.peiFrequency }}
                          <br />
                          <br />
                        </span>

                        <span>
                          <b class="b-text">Duración:</b>
                          <br />
                        </span>
                        <span class="normal-text-no-margin">
                          {{ item.peiDuration }}
                        </span>
                      </div>
                      <div class="col-6">
                        <span>
                          <b class="b-text">
                            ¿El servicio que está ofreciendo en esta área es
                            tiempo compensatorio?
                          </b>
                          <span class="normal-text">
                            {{ item.isCompensatoryTime ? 'Sí' : 'No' }}
                          </span>
                          <br />
                          <br />
                        </span>
                        <span v-if="item.isCompensatoryTime">
                          <b class="b-text">
                            ¿Cuánto tiempo se le adeuda al estudiante en esta
                            área?
                          </b>
                          <span class="normal-text">
                            {{ item.timeDebtedQty }}
                          </span>
                          <br />
                          <br />
                        </span>
                        <div v-if="item.transportation.wasRequested">
                          <span>
                            <b class="b-text">
                              Cuestionario Elegibilidad Transportación
                            </b>
                          </span>
                          <span
                            class="status-chip status-chip-text text-center mr5"
                            :class="{
                              'status-chip-incomplete': !item.transportation
                                .isCompletedFlag,
                            }"
                          >
                            <b class="b-text">Estatus:</b>
                            {{
                              item.transportation.isCompletedFlag
                                ? 'Completado'
                                : 'Incompleto'
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="row ml-3">
                      <div class="info col-2">
                        <span>
                          <b class="b-text">
                            Comentario:
                            <br />
                          </b>
                        </span>
                        <span class="normal-text-no-margin">
                          {{ item.extendedDescription }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="!isEducativo(item)" slot="header-content">
                    <div class="row">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="text-box">
                            <strong class="d-block b-text">Modalidad:</strong>
                            <span class="normal-text-no-margin">
                              {{ item.modalityName }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="text-box">
                            <strong class="d-block b-text">Frecuencia:</strong>
                            <span class="normal-text-no-margin">
                              {{ item.peiFrequency }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="text-box">
                            <strong class="d-block b-text">Duración:</strong>
                            <span class="normal-text-no-margin">
                              {{ item.peiDuration }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="text-box">
                            <strong class="d-block b-text">
                              ¿El estudiante requiere transportación?
                              <span class="normal-text">
                                {{
                                  item.transportation.wasRequested ? 'Sí' : 'No'
                                }}
                              </span>
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="isEducativo(item)" slot="header-content">
                    <div
                      class="d-flex flex-row flex-wrap"
                      style="margin-left: -25px"
                    >
                      <div class="text-box">
                        <strong class="d-block b-text">Inicio de Fecha:</strong>
                        <span class="normal-text-no-margin">
                          {{ item.fromDate | intformatDate }}
                        </span>
                      </div>
                      <div
                        class="text-box"
                        style="margin-right: 20px; margin-left: 40px"
                      >
                        <strong class="d-block b-text">Cierre de fecha:</strong>
                        <span class="normal-text-no-margin">
                          {{ item.toDate | intformatDate }}
                        </span>
                      </div>
                      <div class="text-box b-text">
                        <strong class="d-block">
                          ¿El estudiante requiere transportación?
                          <span class="normal-text">
                            {{ item.transportation.wasRequested ? 'Sí' : 'No' }}
                          </span>
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div slot="action">
                    <div class="dropdown">
                      <button
                        v-if="
                          canEditTab7 &&
                            (admendmentIsEmpty ||
                              !canUseTabEditRestriction ||
                              hasSectionVIIinAmendant)
                        "
                        id="ddAdiestramiento"
                        class="btn btn-dropdown-actions dropdown-toggle pt-1"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Acciones
                      </button>
                      <div
                        class="dropdown-menu cursor"
                        aria-labelledby="ddAdiestramiento"
                      >
                        <a
                          v-if="!IsDraft && canEditTab7"
                          class="dropdown-item"
                          @click="goToQuestionnaireEditorVer(item)"
                        >
                          <i class="fas fa-search text-green" />
                          Ver
                        </a>
                        <a
                          v-if="
                            IsDraft &&
                              canEditTab7 &&
                              (admendmentIsEmpty ||
                                !canUseTabEditRestriction ||
                                hasSectionVIIinAmendant)
                          "
                          class="dropdown-item cursor"
                          @click="goToQuestionnaireEditorVer(item)"
                        >
                          <i class="fas fa-edit text-green" />
                          Editar
                        </a>
                        <a
                          v-if="
                            IsDraft &&
                              canEditTab7 &&
                              (admendmentIsEmpty ||
                                !canUseTabEditRestriction ||
                                hasSectionVIIinAmendant)
                          "
                          class="dropdown-item cursor"
                          @click="deleteRow(item)"
                        >
                          <i class="fas fa-times-circle text-red" />
                          Eliminar
                        </a>
                      </div>
                    </div>
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          </div>

          <div class="bg-rectangle-gradiant" />
          <div
            v-if="
              IsDraft &&
                canEditTab7 &&
                (admendmentIsEmpty ||
                  !canUseTabEditRestriction ||
                  hasSectionVIIinAmendant)
            "
            class="col-12 text-center"
          >
            <button
              id="btnFA"
              class="btn bg-light-white w-75 pt-1"
              @click="goToQuestionnaire"
            >
              <img
                src="../../../assets/img/plus-square.svg"
                class="fas plus-square pr-4 text-green"
              />
              <span class="text-button-add-document">
                Presione aquí para añadir año escolar extendido
              </span>
            </button>
          </div>

          <div class="row">
            <div class="col-12">
              <Error
                v-if="validateServiceAreaExtendedSchool()"
                variant="no-border pt-5"
                :message="resources['7001']"
              />
            </div>
          </div>
        </div>
      </SaveObserver>
    </ValidationObserver>
    <!--Fin Año escolar extendido-->

    <!-- fin Contenido -->
  </div>
</template>

<style scoped src="@/assets/css/pei/parte-k.css"></style>

<script>
import { SectionTitle } from '@/components/pei/shared';
import PreEvaluationAnswer from '../../at/popup/PreEvaluationAnswer';
import CustomInnerPageMessage from '../../common/CustomInnerPageMessage';
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import peiStatus from '@/utils/constants/pei/peiStatus';
import peiProgramAreas from '@/utils/constants/pei/peiProgramAreas';
import moment from 'moment';
import { ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error';
import peiSections from '@/utils/constants/pei/peiSections.js';
import mixAlert from '@/mixin/alert.mixin';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import academicYears from '@/utils/constants/academicYears';
const SUB_SECTION_K = 50;
// Services.
import resourcesService from '@/services/resources.js';
export default {
  name: 'Tab7',
  components: {
    SectionTitle,
    ValidationObserver,
    SaveObserver,
    Error,
    PreEvaluationAnswer: PreEvaluationAnswer,
    CustomInnerPageMessage,
    Accordion,
    AccordionItem,
    MultiSelectionPicker,
    CustomChipsGroup,
    ActionButton,
    CustomDropDown,
  },
  filters: {
    intformatDate(value, format = null) {
      if (value) {
        return moment(value)
          .locale('es-PR')
          .format(format == null ? 'DD/MMM/YYYY' : format);
      }
    },
  },
  mixins: [mixAlert],
  data() {
    return {
      action: {},
      Info: {},
      ReferalRecord: null,
      isShowMessage: false,
      preEvaluationAnswerVisible: 0,
      peiId: store.getters.SelectedPei,
      peiStatus: peiStatus,
      pei: {},
      ListServiceAreaExtendedSchoolYear: [],
      peiProgramAreas: peiProgramAreas,
      extendedSchoolYearFlag: store.getters.getPeiInfo.extendedSchoolYearFlag,
      resources: [],
      isPs: store.getters.getIsPs,
      otherServTechAssistEquipFlag:
        store.getters.getPeiInfo.otherServTechAssistEquipFlag,
      validationMessages: {},
      AcademicYearDescription: '',
      AcademicYearToDate: null,
      serviceAssistTechEquipCommittee: [],
      serviceAssistTechEquipSchool: [],
      callChild: false,
      isAtConverted: store.getters.getAtConversionValue,
      preTechEquipInSchoolClicked: false,
      preTechEquipInSchool: [],
      preTechEquipInSchoolAvailable: [],
      preTechEquipInSchoolBackUp: [],
      preReferalsClicked: false,
      preReferals: [],
      preReferalsAvailable: [],
      preReferalsBackup: [],
      preServiceAssistTechEquipCommitteeClicked: false,
      preServiceAssistTechEquipCommittee: [],
      preServiceAssistTechEquipCommitteeAvailable: [],
      preServiceAssistTechEquipCommitteeBackUp: [],
      selectedFilterCommite: null,
      selectedFilterSchool: null,
      equipmentFilter: [],
      canEditTab7: store.getters.HasPermission('pei.editTab7'),
      configOtherServTechAssistEquipFlag: false,
    };
  },
  async activated() {
    this.$store.commit('setSaveBtnVisibility', false);
    await this.getServiceAreaExtendedSchoolYear();
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '6018',
        'R100561',
        '7001',
        'R03200137',
        'R90012',
        '100',
      ]);
    },
    async DropATGuide(item) {
      const alertResponse = await this.ShowCancelModal(
        'Alerta',
        '¿Está seguro que desea eliminar la guia de AT?',
        'Sí',
        'No'
      );

      if (alertResponse) {
        let self = this;
        await this.$ApiDelete(`api/atservice/dropatguide/${item.id}`)
          .then(async () => {
            self.ShowToast(
              'Proceso exitoso.',
              'La guia de AT fue eliminada exitosamente',
              'success'
            );
            await self.getOtherServices();
            await self.getPei();
          })
          .catch(() => {
            self.ShowToast(
              'Proceso exitoso',
              this.resources['R90012'],
              'error'
            );
          });
      }
    },
    // Validations.
    // Validation for guide AT no complete.
    validateGuideATNoComplete() {
      let activate =
        this.otherServTechAssistEquipFlag === '1' &&
        this.validationTriggered.validation;
      let atPei = null;

      if (this.ReferalRecord && this.ReferalRecord.serviceAssistTechEval) {
        atPei = this.ReferalRecord.serviceAssistTechEval.find(
          (x) => x.peiId === this.peiId
        );
      }

      let throwValidate = atPei != null && atPei.completeFlag === false;

      return activate && throwValidate;
    },
    // Validation so that at least one process contains information.
    validateProcessesContainInformation() {
      let activate =
        this.otherServTechAssistEquipFlag === '1' &&
        this.validationTriggered.validation;

      let throwValidate =
        this.Referals &&
        this.Referals.length <= 0 &&
        this.TechEquipInSchool &&
        this.TechEquipInSchool.length <= 0 &&
        this.EquipmentCommitte &&
        this.EquipmentCommitte.length <= 0;

      if (this.isAtConverted) {
        throwValidate =
          throwValidate &&
          this.preServiceAssistTechEquipCommittee &&
          this.preServiceAssistTechEquipCommittee.length <= 0 &&
          this.preTechEquipInSchool &&
          this.preTechEquipInSchool.length <= 0 &&
          this.preReferals &&
          this.preReferals.length <= 0;
      }

      return activate && throwValidate;
    },
    // Validation of services in extended school year.
    validateServiceAreaExtendedSchool() {
      let activate =
        this.otherServTechAssistEquipFlag === '1' &&
        this.validationTriggered.validation;

      let throwValidate =
        this.ListServiceAreaExtendedSchoolYear &&
        this.ListServiceAreaExtendedSchoolYear.length <= 0;

      return activate && throwValidate;
    },
    async preEvalClick() {
      var currentAcademicYear = this.currentAcademicYear();
      if (currentAcademicYear.toDate > this.AcademicYearToDate) {
        this.ShowToast(
          'Error',
          'Para crear la Guía de Referido para evaluación de AT debe crear un PEI para el año escolar actual.',
          'error'
        );
        return;
      }

      if (this.isAtConverted) {
        const alertResponse = await this.ShowCancelModal(
          'Alerta',
          '¿Está seguro que desea crear un referido nuevo de Asistencia Tecnológica?',
          'Sí',
          'No'
        );
        if (!alertResponse) {
          return;
        }
      }
      this.callChild = !this.callChild;
    },
    serviceName(areaExtended) {
      let areaName = '';
      if (areaExtended != null) {
        if (areaExtended.areaId === this.peiProgramAreas.Otros)
          areaName = `Otro - ${areaExtended.programServiceArea}`;
        else areaName = areaExtended.serviceName;
      }

      return areaName;
    },
    async getOtherServices() {
      let self = this;
      await self
        .$ApiGet(
          '/api/pei/getserviceassisttecheval?peiId=' + store.getters.SelectedPei
        )
        .then((res) => {
          this.configOtherServTechAssistEquipFlag =
            res.data?.configOtherServTechAssistEquipFlag;
          self.ReferalRecord = res.data;
          self.preEvaluationAnswerVisible =
            self.ReferalRecord.serviceAssistTechEval.find(
              (x) => x.peiId == this.peiId
            ) == null;

          this.serviceAssistTechEquipSchool = this
            .configOtherServTechAssistEquipFlag
            ? this.setEquipmentsData(res.data.serviceAssistTechEquipSchool)
            : [];
          this.serviceAssistTechEquipCommittee = this
            .configOtherServTechAssistEquipFlag
            ? this.setEquipmentsData(res.data.serviceAssistTechEquipCommittee)
            : [];
        })
        .catch((err) => {
          self.response = err;
        });
    },
    showMessage() {
      this.isShowMessage = true;
    },
    goToAT(item) {
      store.dispatch('setSelectedAt', item.id);
      store.dispatch('setAtCompleted', item.completeFlag);
      store.commit('setSelectPreEvalAnswer', item.preEvaluationAnswer);
      store.commit('setSelectRecentlyEvalBy', item.recentlyEvalBy);
      this.$router.push({ path: '/pei/at' });
    },
    goToQuestionnaire() {
      let self = this;
      self.$store.commit('setSelectedAreaExtended', null);
      self.$router.push({ path: '/pei/QuestionnaireAEE' });
    },
    async getPei() {
      this.pei = store.state.pei;
    },
    //ECG:Esto se esta llamando en mounted y activated, causa carga doble en primera carga de vista. Por favor mejorar.
    async getServiceAreaExtendedSchoolYear() {
      await this.$ApiGet(
        '/api/pei/getpeiserviceareaextendedschoolyear?peiId=' + this.peiId
      )
        .then((res) => {
          this.AcademicYearDescription = res.data.academicYearDescription;
          this.AcademicYearToDate = res.data.academicYearToDate;
          this.ListServiceAreaExtendedSchoolYear = res.data.items || [];
        })
        .catch((err) => {
          this.response = err;
        });
    },
    isEducativo(item) {
      return this.peiProgramAreas.Educativo === item.disciplineTypeId;
    },
    onExpandItem(item) {
      let self = this;
      self.expandedItemId = item.areaId != 0 ? item.areaId : 0;
    },
    goToQuestionnaireEditorVer(item) {
      let self = this;

      self.$store.commit('setSelectedAreaExtended', item);
      self.$router.push({ path: '/pei/QuestionnaireAEE' });
    },
    async deleteRow(item) {
      let self = this;
      self
        .$ApiDelete(
          '/api/pei/deletepeiserviceareasaee/' + item.programServiceAreaId
        )
        .then((response) => {
          self.DataRow = response.data;
          self.getServiceAreaExtendedSchoolYear();
        })
        .catch((errm) => {
          self.ShowToast(
            errm.message,
            'Error al intentar cargar los datos',
            'error'
          );
        })
        .finally(() => {});
    },
    setEquipmentsData(techEquipments) {
      // This function is meant to group the information by the serviceAssistTechEquipSchool's name

      let techEquipSchool = techEquipments;

      let spaDesc = [];

      for (let item of techEquipSchool) {
        spaDesc.push(item.value);
      }

      spaDesc = spaDesc.filter((item, index, ar) => ar.indexOf(item) === index);

      let response = [];
      for (let item of spaDesc) {
        let object = {
          name: item != undefined ? item : 'N/A',
          equipments: [],
        };
        for (let equipment of techEquipSchool) {
          if (item == equipment.value) {
            let tech = {
              name: equipment.name,
              id: equipment.id,
              isRemoved: equipment.isRemoved,
            };
            object.equipments.push(tech);
          }
        }
        response.push(object);
      }

      return response;
    },
    async getAtPreviousData() {
      let self = this;
      await self
        .$ApiGet(
          '/api/pei/getpreviousatdata/' +
            store.getters.SelectedPei +
            '/' +
            store.getters.SelectedStudent.studentId
        )
        .then((res) => {
          self.preTechEquipInSchoolAvailable =
            res.data.availableSchoolEquipment;
          self.preTechEquipInSchool = res.data.selectedSchoolEquip;

          self.preReferalsAvailable = res.data.availableEvals;
          self.preReferals = res.data.selectedEvals;

          self.preServiceAssistTechEquipCommitteeAvailable =
            res.data.availableCommitteeEquipment;
          self.preServiceAssistTechEquipCommittee =
            res.data.selectedCommitteeEquip;

          self.equipmentFilter = self.getEquipmentFilter();
        })
        .catch((err) => {
          self.response = err;
        });
    },
    preTechEquipInSchoolClick() {
      let backup = this.preTechEquipInSchool;
      this.preTechEquipInSchoolBackUp = [];

      backup.forEach((element) => {
        this.preTechEquipInSchoolBackUp.push(element);
      });
      this.preTechEquipInSchoolClicked = true;
    },
    cancelPreTechEquipInSchool() {
      this.preTechEquipInSchool = this.preTechEquipInSchoolBackUp;
      this.preTechEquipInSchoolClicked = false;
    },
    savePreTechEquipInSchool() {
      //logica para guardar cambios
      let self = this;

      this.$ApiPost(
        'api/pei/SavePreviousAtTechSchool/' + store.getters.SelectedPei,
        this.preTechEquipInSchool
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          this.preTechEquipInSchoolClicked = false;
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });
    },
    preReferalClick() {
      let backup = this.preReferals;
      this.preReferalsBackup = [];

      backup.forEach((element) => {
        this.preReferalsBackup.push(element);
      });
      this.preReferalsClicked = true;
    },
    cancelPreReferal() {
      this.preReferals = this.preReferalsBackup;
      this.preReferalsClicked = false;
    },
    savePreReferal() {
      //logica para guardar cambios
      let self = this;
      this.$ApiPost(
        'api/pei/SavePreviousAtEval/' + store.getters.SelectedPei,
        this.preReferals
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          this.preReferalsClicked = false;
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });

      this.preReferalsClicked = false;
    },
    preServiceAssistTechEquipCommitteeClick() {
      let backup = this.preServiceAssistTechEquipCommittee;
      this.preServiceAssistTechEquipCommitteeBackUp = [];

      backup.forEach((element) => {
        this.preServiceAssistTechEquipCommitteeBackUp.push(element);
      });

      this.preServiceAssistTechEquipCommitteeClicked = true;
    },
    cancelPreServiceAssistTechEquipCommittee() {
      this.preServiceAssistTechEquipCommittee = this.preServiceAssistTechEquipCommitteeBackUp;
      this.preServiceAssistTechEquipCommitteeClicked = false;
    },
    savePreServiceAssistTechEquipCommittee() {
      //logica para guardar cambios
      let self = this;
      this.$ApiPost(
        'api/pei/saveprevioustechcommite/' + store.getters.SelectedPei,
        this.preServiceAssistTechEquipCommittee
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          this.preServiceAssistTechEquipCommitteeClicked = false;
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });
    },
    removeSelectionCommiteEquipment(item) {
      let editedItemIndex = this.preServiceAssistTechEquipCommittee.findIndex(
        (e) => e.id === item.id
      );
      this.preServiceAssistTechEquipCommittee.splice(editedItemIndex, 1);
    },
    removeSelectionSchool(item) {
      let editedItemIndex = this.preTechEquipInSchool.findIndex(
        (e) => e.id === item.id
      );
      this.preTechEquipInSchool.splice(editedItemIndex, 1);
    },
    removeSelectionReferal(item) {
      let editedItemIndex = this.preReferals.findIndex((e) => e.id === item.id);
      this.preReferals.splice(editedItemIndex, 1);
    },
    filterCommite(filter) {
      let result = [];
      if (filter == null) {
        result = this.preServiceAssistTechEquipCommitteeAvailable;
      } else {
        result = this.preServiceAssistTechEquipCommitteeAvailable.filter(
          (e) => e.value == filter.name
        );
      }

      return result;
    },
    filterSchoolEquipment(filter) {
      let result = [];
      if (filter == null) {
        result = this.preTechEquipInSchoolAvailable;
      } else {
        result = this.preTechEquipInSchoolAvailable.filter(
          (e) => e.value == filter.name
        );
      }

      return result;
    },
    getEquipmentFilter() {
      let spaDesc = [];

      for (let item of this.preTechEquipInSchoolAvailable) {
        spaDesc.push(item.value);
      }

      spaDesc = spaDesc.filter((item, index, ar) => ar.indexOf(item) === index);

      let response = [];
      let counter = 0;
      for (let item of spaDesc) {
        let object = {
          name: item,
          id: (counter += 1),
        };
        response.push(object);
      }

      return response;
    },
    onSchoolEquipmentDeleted(id) {
      //logica para eliminar separado
      let self = this;
      this.$ApiPost(
        'api/pei/deleteprevioustechschool/' +
          store.getters.SelectedPei +
          '/' +
          id
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          let editedItemIndex = this.preTechEquipInSchool.findIndex(
            (e) => e.id === id
          );
          this.preTechEquipInSchool.splice(editedItemIndex, 1);
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });
    },
    onCommitteeEquipmentDeleted(id) {
      //logica para eliminar separado
      let self = this;
      this.$ApiPost(
        'api/pei/deleteprevioustechcommittee/' +
          store.getters.SelectedPei +
          '/' +
          id
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          let editedItemIndex = this.preServiceAssistTechEquipCommittee.findIndex(
            (e) => e.id === id
          );
          this.preServiceAssistTechEquipCommittee.splice(editedItemIndex, 1);
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });
    },
    onReferalDeleted(id) {
      //logica para eliminar separado
      let self = this;
      this.$ApiPost(
        'api/pei/deletepreviouseval/' + store.getters.SelectedPei + '/' + id
      )
        .then(() => {
          self.ShowToast('Proceso exitoso', self.resources['100'], 'success');
          let editedItemIndex = this.preReferals.findIndex((e) => e.id === id);
          this.preReferals.splice(editedItemIndex, 1);
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R90012'], 'error');
        });
    },
    guarantaeeUsageHandler() {
      this.$router.push({
        path: `/pei/At/questionary/equipments/${this.peiId}`,
      });
    },
  },
  computed: {
    removedEquipments() {
      const allEquipments = this.TechEquipInSchool
        ? this.TechEquipInSchool.flatMap((x) => x.equipments)
        : [];
      return allEquipments
        .filter((x) => x.isRemoved === true)
        .map((x) => x.name);
    },
    isPeiSigned() {
      return this.selectedPeiStatus === parseInt(peiStatus.Firmado);
    },
    selectedPeiStatus() {
      return store.getters.SelectedPeiStatus;
    },
    Referals: function() {
      if (this.ReferalRecord && this.configOtherServTechAssistEquipFlag) {
        return this.ReferalRecord.serviceAssistTechEval;
      }
      return [];
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    EquipmentCommitte: function() {
      if (this.ReferalRecord) {
        return this.serviceAssistTechEquipCommittee;
      }
      return null;
    },
    TechEquipInSchool: function() {
      if (this.ReferalRecord) {
        return this.serviceAssistTechEquipSchool;
      }
      return null;
    },
    IsDraft: function() {
      return store.getters.getPeiInfo.peiStatusCode == peiStatus.Borrador;
    },
    controversyVII() {
      return store.getters.getPeiControversies(peiSections.VII);
    },
    educationalProgramArea() {
      return this.peiProgramAreas.Educativo;
    },
    preServiceAssistTechEquipCommitteeFormatted() {
      return this.setEquipmentsData(this.preServiceAssistTechEquipCommittee);
    },
    preTechEquipInSchoolFormatted() {
      return this.setEquipmentsData(this.preTechEquipInSchool);
    },
    preTechCommitteeFiltered() {
      return this.filterCommite(this.selectedFilterCommite);
    },
    preTechSchoolFiltered() {
      return this.filterSchoolEquipment(this.selectedFilterSchool);
    },
    canShowGuarantaeeUsageAction() {
      return (
        store.getters.getRequireUsageGuaranteeCompletionEnabled === 'true' &&
        store.getters.getPeiInfo.academicYearId >= academicYears.Y2024_2025 &&
        this.TechEquipInSchool != null &&
        this.TechEquipInSchool.some((c) => c.equipments.length > 0)
      );
    },
    admendmentIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    canUseTabEditRestriction() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    hasSubSectionKinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_K
      );
    },
    hasSectionVIIinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.sectionId == parseInt(peiSections.VII)
      );
    },
  },
  async mounted() {
    let self = this;
    store.dispatch('setSelectedAt', 0);
    await self.loadResources();
    this.Info = self.$attrs.Info;
    await self.getOtherServices();
    await self.getPei();
    await self.getServiceAreaExtendedSchoolYear();
    await this.getAtPreviousData();
  },
};
</script>
